import type { TimelineEvent } from "@productlane/api/src/browser"
import type { ThreadActivityPayloadMap } from "@productlane/lib/src/browser"
import { parseThreadActivity } from "@productlane/lib/src/browser"

export const FEATURE_REQUEST_CARD_EVENT_TYPE = "feature_request_card"

export type FeatureRequestCardPayload =
	ThreadActivityPayloadMap["feature_request_card"]

export function parseFeatureRequestCardPayload(
	payload: unknown,
): FeatureRequestCardPayload | null {
	try {
		const parsed = parseThreadActivity(FEATURE_REQUEST_CARD_EVENT_TYPE, payload)
		return parsed.eventType === FEATURE_REQUEST_CARD_EVENT_TYPE
			? parsed.payload
			: null
	} catch {
		return null
	}
}

export function isFeatureRequestCardEvent(event: TimelineEvent): boolean {
	return (
		event.type === "activity" &&
		event.threadActivity.eventType === FEATURE_REQUEST_CARD_EVENT_TYPE
	)
}
